<!-- eslint-disable max-len -->
<template>
  <div>
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          v-if="selectedArticle.highlightedImageUrl"
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />

        <img
          v-else
          src="assets/images/no-image.jpg"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />

        <!-- <Photo src="assets/images/no-image.jpg" v-else /> -->
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">{{translations.goToShoppingCart}}</button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">{{translations.continueShopping}}</button>
        </div>
      </div>
    </modal>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id" />
      </div>
    </modal>
    <div class="container">
      <div class="row">
        <div class="col-lg-9 col-xl-5col-4">
          <nav class="toolbox mb-4 row">
            <div class="col-12 col-sm-6 d-flex">
              <div class="toolbox-item toolbox-sort">
                <div class="select-custom">
                  <select
                    name="orderby"
                    class="form-control"
                    v-model="sortField"
                    @change="handleSortChange"
                  >
                    <option :value="item.id" v-for="item in sortFields" :key="item.id">
                      {{ translations[item.label] }}
                    </option>
                  </select>
                </div>
                <!-- End .select-custom -->
              </div>
              <div class="toolbox-item toolbox-sort">
                <div class="select-custom">
                  <select
                    class="form-control"
                    name="results-per-page"
                    v-model="searchConfig.pageSize"
                    @change="changePageSize(searchConfig.pageSize)"
                  >
                    <option :value="page" v-for="page in pageSizeList" :key="page">
                      {{ page }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- End .toolbox-item -->
            </div>
            <!-- End .toolbox-left -->
            <div
              :class="
                [
                  'col-12 col-sm-6',
                  'justify-content-between justify-content-md-end',
                  'align-items-center',
                  'd-flex',
                ].join(' ')
              "
            >
              <label class="d-flex d-sm-none d-md-flex">{{ paginationResultsTitle }}</label>
              <div class="layout-modes d-none d-md-flex justify-content-end">
                <div
                  class="layout-btn btn-grid"
                  title="Grid"
                  :class="{ active: layout === 'grid' }"
                  @click="layout = 'grid'"
                >
                  <i class="fa fa-th"></i>
                </div>
                <div
                  class="layout-btn btn-list"
                  title="List"
                  :class="{ active: layout === 'list' }"
                  @click="layout = 'list'"
                >
                  <i class="fa fa-th-list"></i>
                </div>
                <div
                  class="layout-btn btn-bars"
                  title="Bars"
                  :class="{ active: layout === 'bars' }"
                  @click="layout = 'bars'"
                >
                  <i class="fas fa-bars"></i>
                </div>
              </div>
              <!-- End .layout-modes -->
            </div>
            <!-- End .toolbox-item -->
          </nav>
          <div class="row row-sm" v-if="articles && articles.length > 0 && layout === 'grid'">
            <div class="col-6 col-md-4 col-lg-3 mb-2" v-for="item in articles" :key="item.id">
              <div class="product-default inner-quickview inner-icon bg-white h-100 mb-0">
                <figure>
                  <router-link :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }">
                    <Photo
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />
                    <Photo src="assets/images/no-image.jpg" v-else />
                  </router-link>
                  <div
                    v-if="
                      item.oldPrice &&
                      item.oldPrice !== item.price &&
                      (!item.salePrice || (item.salePrice || 0) === 0)
                    "
                    class="label-group"
                  >
                    <span class="product-label label-cut">
                      {{ (100 * (1 - item.price / item.oldPrice)) | percentage }}%
                    </span>
                  </div>
                  <div v-if="item.salePrice || (item.salePrice || 0) > 0" class="label-group">
                    <span class="product-label label-cut">
                      {{ item.saleDiscountPercentage | percentage }}% {{ translations.sale }}
                    </span>
                  </div>
                  <div class="btn-icon-group" v-if="!item.disableSelling || canPassRestrictions">
                    <button class="btn-icon btn-add-cart" @click="addToCart(item)">
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="icon-bag" v-else />
                    </button>
                  </div>
                  <button
                    class="btn btn-sm btn-quickview"
                    data-toggle="modal"
                    @click="getQuickArticle(item.id)"
                  >
                    {{ translations.quickPreview }}
                  </button>
                </figure>
                <div class="product-details">
                  <div class="category-wrap">
                    <div class="category-list">
                      <router-link
                        v-if="item.brandId"
                        class="product-category"
                        :to="{ name: 'Brand', params: { id: item.brandId, title: item.brand.replace(/\s+/g, '-') } }"
                      >
                        {{ item.brand }}
                      </router-link>
                      <span v-else class="product-category">
                        {{ item.brand }}
                      </span>
                    </div>
                    <a
                      href="#"
                      @click.stop.prevent="toggleWishlistItem(item.id)"
                      class="btn-icon-wish"
                    >
                      <i class="icon-heart"></i>
                    </a>
                  </div>
                  <h2 class="product-title">
                    <router-link :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }">
                      {{ item.title }}
                    </router-link>
                  </h2>
                  <div class="ratings-container">
                    {{ translations.forms.labels.code }}: {{ item.code }}
                    <!-- End .product-ratings -->
                  </div>
                  <!-- End .product-container -->
                  <div class="price-box" v-if="canViewPrices && !item.disableSelling">
                    <span class="product-price" v-if="(!item.salePrice || (item.salePrice || 0) === 0)">{{ item.price | money3WithCurrency }}</span>
                    <span class="product-price" v-if="item.salePrice || (item.salePrice || 0) > 0">{{ item.salePrice | money3WithCurrency }}</span>
                    <span class="old-price" v-if="item.oldPrice && item.price !== item.oldPrice">
                      {{ item.oldPrice | money3 }} KM
                    </span>
                    <span class="old-price" v-if="item.salePrice || (item.salePrice || 0) > 0">
                      {{ item.oldPrice | money3 }} KM
                    </span>
                  </div>
                  <!-- End .price-box -->
                  <button
                    v-if="
                      (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                      !canPassRestrictions
                    "
                    class="btn btn-primary btn-sm py-2 px-0 text-center btn-block"
                    @click="showOutOfStockModal(item)"
                  >
                    {{ translations.availableOnRequest }}
                  </button>
                </div>
                <!-- End .product-details -->
              </div>
            </div>
          </div>

          <div class="row row-sm" v-if="layout === 'list' && articles && articles.length > 0">
            <div
              class="col-6 product-default left-details product-list col-sm-12"
              v-for="item in articles"
              :key="item.id"
            >
              <figure>
                <router-link :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }">
                  <img
                    :src="`${baseUrl}${item.highlightedImageUrl}`"
                    v-if="item.highlightedImageUrl"
                  />
                  <img src="assets/images/no-image.jpg" v-else />
                  <div class="label-group" style="position: absolute; top: 5px; left: 5px">
                    <span
                      v-if="
                        item.oldPrice &&
                        item.oldPrice !== item.price &&
                        (!item.salePrice || (item.salePrice || 0) === 0)
                      "
                      class="product-label label-cut"
                      >{{ (100 * (1 - item.price / item.oldPrice)) | percentage }}%</span
                    >
                    <span
                      v-if="item.salePrice || (item.salePrice || 0) > 0"
                      class="product-label label-cut"
                      >{{ item.saleDiscountPercentage | percentage }}% {{ translations.sale }}</span
                    >
                  </div>
                </router-link>
              </figure>
              <div class="product-details product-details-list">
                <div class="category-list">
                  <router-link
                    v-if="item.brandId"
                    class="product-category"
                    :to="{ name: 'Brand', params: { id: item.brandId, title: item.brand.replace(/\s+/g, '-') } }"
                  >
                    {{ item.brand }}
                  </router-link>
                  <span v-else class="product-category">
                    {{ item.brand }}
                  </span>
                </div>
                <h2 class="product-title">
                  <router-link :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }">
                    {{ item.title }}
                  </router-link>
                </h2>
                <div class="ratings-container">
                  {{ translations.forms.labels.code }}: {{ item.code }}</div>
                <!-- End .product-container -->
                <p class="product-description" v-html="item.shortDescription">
                </p>
                <div
                  class="price-box"
                  v-if="
                    canViewPrices &&
                    !item.disableSelling &&
                    (!item.salePrice || (item.salePrice || 0) === 0)
                  "
                >
                  <span class="product-price">{{ item.price | money3WithCurrency }}</span>
                  <span class="old-price" v-if="item.oldPrice && item.price !== item.oldPrice">
                    {{ item.oldPrice | money3 }} KM
                  </span>
                </div>
                <div
                  class="price-box"
                   v-if="item.salePrice || (item.salePrice || 0) > 0"
                >
                  <span class="product-price">{{ item.salePrice | money3WithCurrency }}</span>
                  <span class="old-price"> {{ item.price | money3 }} KM </span>
                </div>
                <!-- End .price-box -->
                <div class="product-action">
                  <div
                    v-if="!item.disableSelling || canPassRestrictions"
                    class="product-single-qty product-list-quantity"
                  >
                    <div class="input-group">
                      <span
                        class="input-group-btn input-group-prepend"
                        @click="setQuantity(item, -1)"
                      >
                        <button class="btn btn-outline btn-down-icon" type="button" />
                      </span>
                      <input
                        class="horizontal-quantity form-control"
                        v-model.number="item.quantity"
                      />
                      <span
                        class="input-group-btn input-group-append"
                        @click="setQuantity(item, 1)"
                      >
                        <button class="btn btn-outline btn-up-icon" type="button" />
                      </span>
                    </div>
                  </div>
                  <button
                    v-if="!item.disableSelling || canPassRestrictions"
                    class="btn-icon btn-add-cart"
                    @click="addToCart(item)"
                  >
                    <i class="sicon-equalizer" v-if="item.hasAttributes" />
                    <i class="icon-bag" v-else />
                    {{ item.hasAttributes ? translations.chooseOptions : translations.addToCart }}
                  </button>
                  <button
                    v-if="
                      (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                      !canPassRestrictions
                    "
                    class="btn-icon btn-add-cart"
                    @click="showOutOfStockModal(item)"
                  >
                    {{ translations.availableOnRequest }}
                  </button>
                  <a
                    href="#"
                    @click.stop.prevent="toggleWishlistItem(item.id)"
                    class="btn-icon-wish"
                  >
                    <i class="icon-heart"></i>
                  </a>

                  <button class="btn-quickview" @click="getQuickArticle(item.id)">
                    <i class="fas fa-external-link-alt"></i>
                  </button>
                </div>
              </div>
              <!-- End .product-details -->
            </div>
          </div>

          <div
            class="table-product-list"
            v-if="layout === 'bars' && articles && articles.length > 0"
          >
            <table class="table text-left">
              <thead>
                <tr>
                  <th>{{ translations.manufacturer }}</th>
                  <th>{{ translations.forms.labels.code }}</th>
                  <th>{{ translations.productName }}</th>
                  <th>{{ translations.preview }}</th>
                  <th v-if="canViewPrices">{{ translations.price }}</th>
                  <th>{{ translations.discount }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in articles" :key="item.id">
                  <td>
                    {{ item.brand }}
                  </td>
                  <td>
                    {{ item.code }}
                  </td>
                  <td>
                    <router-link :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }">
                      {{ item.title }}
                    </router-link>
                  </td>
                  <td>
                    <img
                      class="small-product-list-img"
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />

                    <img class="small-product-list-img" src="assets/images/no-image.jpg" v-else />
                  </td>
                  <td v-if="canViewPrices && !item.disableSelling">
                    {{ item.price | money3WithCurrency }}
                  </td>
                  <td v-if="item.saleDiscountPercentage && (item.saleDiscountPercentage || 0) > 0.1">
                    {{ item.saleDiscountPercentage | percentage }}%
                  </td>
                  <td
                    v-else-if="
                      item.pricePolicyDiscountPercentage &&
                      (item.pricePolicyDiscountPercentage || 0) > 0.1
                    "
                  >
                    {{ item.pricePolicyDiscountPercentage | percentage }}%
                  </td>
                  <td v-else>{{ item.discount > 0.1 ? item.discount + '%' : '-' }}</td>
                  <td class="order-actions justify-content-end">
                    <div
                      class="product-single-qty"
                      v-if="!item.disableSelling || canPassRestrictions"
                    >
                      <div class="input-group bootstrap-touchspin">
                        <span
                          class="input-group-btn input-group-prepend"
                          @click="setQuantity(item, -1)"
                        >
                          <button class="btn btn-outline btn-down-icon" type="button" />
                        </span>
                        <input
                          class="horizontal-quantity form-control"
                          v-model.number="item.quantity"
                        />
                        <span
                          class="input-group-btn input-group-append"
                          @click="setQuantity(item, 1)"
                        >
                          <button class="btn btn-outline btn-up-icon" type="button" />
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="!item.disableSelling || canPassRestrictions"
                      class="btn-icon btn-add-cart"
                      @click="addToCart(item)"
                    >
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="fas fa-shopping-bag" v-else />
                    </div>
                    <div
                      v-if="
                        !canPassRestrictions &&
                        (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero))
                      "
                      class="btn-icon"
                      role="button"
                      @click="showOutOfStockModal(item)"
                    >
                      <button class="paction add-cart">{{ translations.availableOnRequest }}</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination :action="actionName" :pagination-props="paginationProps" />
        </div>
        <!-- End .col-lg-9 -->
        <aside class="sidebar-shop col-lg-3 col-xl-5col-1 order-lg-first">
          <div class="sidebar-wrapper">
            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-body-2"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-body-2"
                >
                {{ translations.categories }}
                </a>
              </h3>
              <div class="collapse show" id="widget-body-2">
                <div class="widget-body">
                  <tree-view
                    v-for="item in treeView"
                    :key="item.id"
                    :item="item"
                    :is-open="isOpenFilter(item)"
                  />
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>
            <!-- End .widget -->
            <div class="widget" v-if="filters && filters.maxPriceInThisCategory">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-body-3"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-body-3"
                >
                  {{ translations.priceRange }}
                </a>
              </h3>
              <div class="collapse show" id="widget-body-3">
                <div>
                  <div class="filter-price-action">
                    <div class="filter-price-text">
                      <div class="filter-price-text">
                      VPC: {{ parseFloat(filters.minPriceInThisCategory).toFixed(2) }} KM - VPC:
                      {{ parseFloat(filters.maxPriceInThisCategory).toFixed(2) }} KM
                    </div>
                    </div>
                    <!-- End .filter-price-text -->
                  </div>
                  <div class="d-flex">
                    <input
                      ref="priceInput0"
                      type="number"
                      class="form-control form-control-sm price-range-min"
                      v-model="priceRange[0]"
                      @keyup="handlePriceChangeOnEnter"
                      @blur="roundPrice"
                    />
                    <input
                      ref="priceInput1"
                      type="number"
                      class="form-control form-control-sm price-range-max"
                      v-model="priceRange[1]"
                      @keyup="handlePriceChangeOnEnter"
                      @blur="roundPrice"
                    />
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="handlePriceChange"
                    >
                    {{ translations.apply }}
                    </button>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-on-stock"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-on-stock"
                >
                {{ translations.stock }}
                </a>
              </h3>
              <div class="collapse show" id="widget-on-stock">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="onStock"
                      :id="'checkbox-on-stock'"
                    />
                    <label class="custom-control-label" :for="'checkbox-on-stock'">
                      {{ translations.isInStock }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-brands"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-brands"
                  >{{ translations.brands }}</a
                >
              </h3>
              <div class="collapse show" id="widget-brands" v-if="filters && filters.brands">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in filters.brands"
                    :key="item.brandId"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.brandId"
                      v-model="brandIds"
                      :id="`checkbox-${item.brandId}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-${item.brandId}`">
                      {{ item.title }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div v-if="filters && filters.attributes">
              <div class="widget" v-for="attribute in filters.attributes" :key="attribute.id">
                <h3 class="widget-title">
                  <a
                    data-toggle="collapse"
                    :href="`#widget-body-attribute-${attribute.id}`"
                    role="button"
                    >{{ attribute.title }}</a
                  >
                </h3>
                <div class="collapse show" :id="`widget-body-attribute-${attribute.id}`">
                  <div class="widget-body">
                    <div v-if="attribute.attributeStyle !== 1">
                      <div
                        class="custom-control custom-checkbox category-checkbox"
                        v-for="item in attribute.attributeProperties"
                        :key="item.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="item.id"
                          v-model="attributeValuesIds"
                          :id="`checkbox-attribute-${item.id}`"
                        />
                        <label class="custom-control-label" :for="`checkbox-attribute-${item.id}`">
                          {{ item.title }}
                        </label>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="custom-control custom-checkbox category-checkbox"
                        v-for="item in attribute.attributeProperties"
                        :key="item.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="item.id"
                          v-model="attributeValuesIds"
                          :id="`checkbox-attribute-${item.id}`"
                        />
                        <label class="custom-control-label" :for="`checkbox-attribute-${item.id}`">
                        </label>
                        <label
                          :for="`checkbox-attribute-${item.id}`"
                          class="custom-color-label"
                          :style="{ backgroundColor: item.title }"
                        >
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- End .widget-body -->
                </div>
                <!-- End .collapse -->
              </div>
            </div>

            <div class="widget" v-if="filters && filters.tags">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-tags"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-tags"
                >
                {{ translations.tags }}
                </a>
              </h3>
              <div class="collapse show" id="widget-tags">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in filters.tags"
                    :key="item.id"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.id"
                      v-model="tagIds"
                      :id="`checkbox-tag-${item.id}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-tag-${item.id}`">
                      #{{ item.tagTitle }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>
          </div>
          <!-- End .sidebar-wrapper -->
        </aside>
        <!-- End .col-lg-3 -->
      </div>
      <!-- End .row -->
    </div>
    <!-- End .container -->
  </div>
</template>

<script>
import 'vue-range-component/dist/vue-range-slider.css';

import config from '@/config';
import api from '@/services/api';
import Photo from '@/components/shared/Image.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';
import Pagination from '@/components/shared/Pagination.vue';
import TreeView from '@/components/shared/tree-view/TreeView.vue';

import { translations, pager } from '@/mixins';
import slugify from '@/filters/slugify';

export default {
  name: 'Category',
  mixins: [translations, pager],
  components: {
    QuickPreview,
    Pagination,
    Photo,
    Modal,
    TreeView,
  },
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getArticles',
      layout: 'grid', // Can be list or grid
      priceRange:
        query?.minPrice && query?.maxPrice
          ? [parseFloat(query?.minPrice, 10), parseFloat(query?.maxPrice, 10)]
          : [],
      // eslint-disable-next-line no-nested-ternary
      brandIds: query?.brandIds
        ? (
          Array.isArray(query?.brandIds)
            ? query?.brandIds?.map((i) => parseInt(i, 10))
            : [parseInt(query.brandIds, 10)]
        ) : [],
      attributeValuesIds: [],
      onStock: false,
      // eslint-disable-next-line no-nested-ternary
      tagIds: query?.tagIds
        ? (
          Array.isArray(query?.tagIds)
            ? query?.tagIds?.map((i) => parseInt(i, 10))
            : [parseInt(query.tagIds, 10)]
        ) : [],
      selectedArticle: null,
      sortField: query?.sortField ? parseInt(query.sortField, 10) : 1,
    };
  },
  computed: {
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    paginationProps() {
      const sortField = this.sortFields.find((i) => i.id === this.sortField);

      return {
        pageSize: this.searchConfig.pageSize,
        categoryIds: [...this.childCategoryIds, parseInt(this.$route.params.id, 10)],
        brandIds: this.brandIds,
        attributeValuesIds: this.attributeValuesIds,
        minPrice: parseFloat(this.priceRange[0], 10),
        maxPrice: parseFloat(this.priceRange[1], 10),
        tagIds: this.tagIds,
        sortField: this.sortField,
        sortBy: sortField.field,
        isSortAscending: sortField.isSortAscending,
      };
    },
    articles() {
      return this.$store.getters.getArticles;
    },
    filters() {
      return this.$store.getters.getCategoriesFilter;
    },
    baseUrl() {
      return config.baseUrl;
    },
    category() {
      return this.$store.getters.getCategoryById(this.$route.params.id);
    },
    treeView() {
      return this.$store.getters.getCategoriesTreeView;
    },
    prices() {
      if (!this.filters?.maxPriceInThisCategory) return [0, 10000];
      return [this.filters?.minPriceInThisCategory, this.filters?.maxPriceInThisCategory];
    },
    childCategoryIds() {
      return this.$store.getters.getChildrenCategoryIds(parseInt(this.$route.params.id, 10));
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  methods: {
    slugify,
    showOutOfStockModal(item) {
      this.$store.dispatch('showOutOfStockModal', { articleId: item.id });
    },
    isOpenFilter(item) {
      const routeId = parseInt(this.$route.params.id, 10);
      if (item.id === routeId) {
        return true;
      }
      if (item.children?.length) {
        for (let i = 0; i < item.children?.length; i += 1) {
          const foundCat = this.isOpenFilter(item.children[i]);
          if (foundCat) {
            return true;
          }
        }
      }
      return false;
    },
    handlePriceChangeOnEnter(event) {
      if (event.key === 'Enter') {
        if (parseFloat(this.priceRange[0], 10) > parseFloat(this.priceRange[1], 10)) {
          this.priceRange[0] = this.filters.minPriceInThisCategory;
        }
        this.$refs.priceInput0.blur();
        this.$refs.priceInput1.blur();
        this.minPrice = parseFloat(this.priceRange[0], 10);
        this.maxPrice = parseFloat(this.priceRange[1], 10);
        this.filterArticles();
      }
    },
    roundPrice() {
      this.priceRange[0] = parseFloat(this.priceRange[0]).toFixed(2);
      this.priceRange[1] = parseFloat(this.priceRange[1]).toFixed(2);
    },
    filterArticles() {
      const sortField = this.sortFields.find((i) => i.id === this.sortField);

      this.$store.dispatch('getArticles', {
        ...this.searchConfig,
        ...this.paginationProps,
        sortBy: sortField.field,
        isSortAscending: sortField.isSortAscending,
        onStock: this.onStock === false ? null : true,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            sortBy: sortField.field,
            isSortAscending: sortField.isSortAscending,
            page: 1,
          },
        })
        .catch(() => {});
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.filterArticles();
        this.$store.dispatch('getWishList');
      });
    },
    getCategoriesFilters() {
      this.$store.dispatch('getCategoriesFilter', {
        categoryIds: [...this.childCategoryIds, parseInt(this.$route.params.id, 10)],
      });
    },
    handlePriceChange() {
      if (parseFloat(this.priceRange[0], 10) > parseFloat(this.priceRange[1], 10)) {
        this.priceRange[0] = this.filters.minPriceInThisCategory;
      }
      this.minPrice = parseFloat(this.priceRange[0], 10);
      this.maxPrice = parseFloat(this.priceRange[1], 10);
      this.filterArticles();
    },
    addToCart(item) {
      if (item.hasAttributes || (!item.stockAmount && !this.allowOrderingStockZero)) {
        this.$router.push({ name: 'Article', params: { id: item.id, slug: slugify(item.title) } });
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.id,
          quantity: item.quantity || 1,
        })
        .then(() => {
          if (this.layout !== 'bars') {
            $('#addCartModal').modal('show');
          } else {
            this.$toast.info(this.translations.itemAddedToCart);
          }
          this.$store.dispatch('getShoppingCart');
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getShoppingCart');
        });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        setTimeout(() => {
          $('#quick-preview-article').modal('show');
        }, 200);
      });
    },
    handleSortChange() {
      this.filterArticles();
    },
    setQuantity(item, num) {
      if (item.quantity === 1 && num === -1) return;
      // eslint-disable-next-line no-param-reassign
      item.quantity += num;
    },
    handleScroll() {
      localStorage.setItem('categoryScrollPosition', window.scrollY);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    const { query } = this.$route;
    const scrollPosition = localStorage.getItem('categoryScrollPosition');
    const prevRouteName = localStorage.getItem('prevRouteName');
    if (scrollPosition && prevRouteName === 'Article') {
      window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const sortField = this.sortFields.find((i) => i.id === this.sortField);

    this.$store.dispatch(this.actionName, {
      ...this.searchConfig,
      ...this.paginationProps,
      sortBy: sortField.field,
      isSortAscending: sortField.isSortAscending,
      page: query?.page ? parseInt(query.page, 10) : 1,
    });

    this.getCategoriesFilters();
    this.$store.dispatch('getAttributes', { retrieveAll: true });
    this.roundPrice();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    prices() {
      this.priceRange = this.prices;
    },
    brandIds() {
      this.filterArticles();
    },
    attributeValuesIds() {
      this.filterArticles();
    },
    tagIds() {
      this.filterArticles();
    },
    onStock() {
      this.filterArticles();
    },
    '$route.params.id': function reset() {
      this.filterArticles();
      this.getCategoriesFilters();
    },
  },
};
</script>

<style lang="scss" scoped>
.product-default .product-title {
  display: block;
  width: 100%;
}

.product-list .product-details {
  width: calc(100% - 270px);
}

.layout-btn {
  cursor: pointer;
}

.category-checkbox {
  margin-top: 0;
  margin-bottom: 1rem;
}

.custom-color-label {
  width: 20px;
  height: 20px;
  background: black;
}

.custom-color-label {
  width: 6rem;
  height: 2rem;
}

.order-actions {
  display: flex;
  border-top: none !important;
  margin-top: 10px;

  .product-single-qty {
    max-width: unset;
    max-height: unset;
  }

  .product-single-qty .bootstrap-touchspin.input-group {
    max-height: 30px;
  }

  .product-single-qty .bootstrap-touchspin .form-control {
    max-height: 30px;
  }

  i {
    color: #1e84bc;
    font-size: 1.7rem;
    margin-right: 1.5rem;
    padding-left: 5px;
  }

  .btn-icon.btn-add-cart {
    display: inline-block;
    padding-top: 5px;
    line-height: 1;
    height: 20px;
    margin-left: 10px;
  }
}

.btn-add-cart {
  cursor: pointer;
}

.product-list-quantity {
  height: 37px;
  margin-bottom: 5px;
  margin-right: 5px;

  .horizontal-quantity {
    height: 37px;
  }
}

.product-default:hover figure img:first-child {
  opacity: 1;
}
</style>
